import React, { Fragment, useEffect, useRef } from 'react';
import { Button, Input, Tooltip } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, EditOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  border: 1px solid transparent;
  background-color: transparent;
`;

const StyledNoBorderButton = styled(Button)`
  margin-right: 10;
  padding: 0px 5px;
  border: 1px solid transparent;
  background-color: transparent;
`;

const StyledCloseCircleOutlined = styled(CloseCircleOutlined)`
  font-size: 16px;
`;

const StyledEditOutlined = styled(EditOutlined)`
  font-size: 16px;
`;

const StyledCheckCircleOutlined = styled(CheckCircleOutlined)`
  font-size: 16px;
`;

const TemplateEditName = ({
  isCloseClick,
  name,
  setName,
  showEdit,
  setShowEdit,
  showButtons,
  onExec,
  onCancel,
  isValid,
  setValid,
}) => {
  const editInput = useRef(null);

  useEffect(() => {
    if (showEdit) {
      editInput.current.focus();
    }
  }, [showEdit]);

  return showEdit ? (
    <>
      <Input
        ref={editInput}
        className={isValid ? '' : 'not-valid'}
        value={name}
        placeholder="Name of template"
        onChange={(e) => {
          setValid(true);
          setName(e.target.value);
        }}
      />
      {showButtons ? (
        <>
          <StyledButton
            disabled={!name.trim().length}
            onClick={(e) => {
              onExec();
              if (isCloseClick) {
                e.stopPropagation();
              }
              // для гашения фокуса после нажатия
              e.target.blur();
            }}
          >
            <StyledCheckCircleOutlined />
          </StyledButton>
          <StyledButton
            onClick={(e) => {
              onCancel();
              if (isCloseClick) {
                e.stopPropagation();
              }
              // для гашения фокуса после нажатия
              e.target.blur();
            }}
          >
            <StyledCloseCircleOutlined />
          </StyledButton>
        </>
      ) : undefined}
    </>
  ) : (
    <Tooltip placement="bottom" title="Edit name">
      <StyledNoBorderButton
        onClick={(e) => {
          setShowEdit(!showEdit);
          if (isCloseClick) {
            e.stopPropagation();
          }
          // для гашения фокуса после нажатия
          e.target.blur();
        }}
      >
        <StyledEditOutlined />
      </StyledNoBorderButton>
    </Tooltip>
  );
};

export default TemplateEditName;
